import React from 'react'

const Footer = () => {
    return(
        <footer class="mt-16 px-10 py-10">
        <div class="w-3/5 grid grid-cols-3 max-[1100px]:w-4/5 max-md:w-full max-sm:grid max-sm:grid-cols-1 max-sm:gap-10">
          <div class="max-sm:text-center">
            <h2 class="font-bold text-white text-lg">Our Conacts</h2>
            <p class="text-white font-normal mt-7">kircheconsultants@gmail.com</p>
            <p class="text-white font-normal mt-3">P.O.BOX 4921-30100</p>
            <p class="text-white font-normal mt-3">Eldoret, Kenya</p>
          </div>

          <div class="ml-16 max-sm:ml-0 max-sm:text-center">
            <h2 class="font-bold text-white text-lg">Links</h2>
            <p class="text-white font-normal mt-7"><a href="#home">home</a></p>
            <p class="text-white font-normal mt-3"><a href="#about">about</a></p>
            <p class="text-white font-normal mt-3"><a href="#contact">contact us</a></p>
          </div>

          <div class="max-sm:text-center">
            <h2 class="font-bold text-white text-lg">Updates</h2>
            <p class="text-white font-normal mt-7">Launches</p>
            <p class="text-white font-normal mt-3">Schedules</p>
            <p class="text-white font-normal mt-3">Announcements</p>
          </div>
        </div>
      </footer>
    )
}

export default Footer